import { Constants } from '@seedlang/constants';
import { values, flatten, uniq } from 'lodash';

export default function removeArticleFromText(text, languageId) {
  if (!text || typeof text !== 'string') return text;
  if (!languageId) return text;

  const singularArticles = Constants.SINGULAR_ARTICLES[languageId];
  const pluralArticles = Constants.PLURAL_ARTICLES[languageId];
  
  const allArticles = uniq(flatten([
    singularArticles ? values(singularArticles) : [],
    pluralArticles ? values(pluralArticles) : []
  ])).filter(article => article && article.length > 0);

  if (allArticles.length === 0) return text;

  const articlePattern = allArticles
    .map(article => article.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('|');
  
  const regex = new RegExp(`^(${articlePattern})\\s+`, 'i');
  return text.replace(regex, '');
}
